export const state = {
  data: {
    status: false,
    total: 0,
    imported: 0,
  },
}

export const getters = {
  importProgress: (state) => state.data,
}

export const mutations = {
  setImportProgress(state, input) {
    state.data = input
  },
}

export const actions = {
  updateImportProgress({ commit }, payload) {
    commit('setImportProgress', payload)
  },
}
